<template>
  <vx-card no-shadow>

    <ValidationObserver ref="form" v-slot="{ handleSubmit }">
      <form @submit.prevent="handleSubmit(onClickSubmit)" autocomplete="off">


        <span class="label mb-8 ">Any naturally-occurring biologically active principles present in this product, as listed in Annex III of Regulation 1334/2008, must be declared, together with maximum levels</span>

        <div class="vx-row mb-3 mt-8">
          <div class="vx-col md:w-1/3 md:mb-0">
            <ValidationProvider vid="is_contain_BAP" name="is_contain_BAP" rules="" v-slot="{ errors }">
              <small class="label">Does this product contain any biologically active principles?</small>
              <vs-switch :disabled="__isDisabledRawMaterial(status)" v-model="form.is_contain_BAP" icon-pack="feather" vs-icon-on="icon-check-circle" vs-icon-off="icon-slash" class="mt-2 w-16">
                <span slot="on">Yes</span>
                <span slot="off">No</span>
              </vs-switch>
            </ValidationProvider>
          </div>
          <div class="vx-col md:w-2/3 w-full md:mb-0">
<!--            <ValidationProvider v-if="form.is_contain_BAP" vid="is_contain_BAP_comment" name="is_contain_BAP_comment" rules="required" v-slot="{ errors }">-->
<!--              <small class="label">Comment</small>-->
<!--              <vs-input :disabled="__isDisabledRawMaterial(status)" type="text" v-model="form.is_contain_BAP_comment" name="is_contain_BAP_comment" class="w-full"  :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather" />-->
<!--            </ValidationProvider>-->
          </div>
        </div>

        <vs-table v-if="form.is_contain_BAP" :data="form.BAP_item"  :sst="true" stripe class="table-dark-inverted table-auto vs-con-loading__container">>
          <template slot="thead">
            <vs-th style="font-weight: normal" width="30%">Name</vs-th>
            <vs-th style="font-weight: normal" width="70%">Levels</vs-th>
          </template>

          <template slot-scope="{data}">
            <vs-tr style="cursor: pointer"   :key="indextr" v-for="(tr, indextr) in data">

              <vs-td :data="data[indextr].name">
                {{BAP_item_display_names[indextr]}}
              </vs-td>
              <vs-td :data="data[indextr].is_contain">
                <ValidationProvider :vid="indextr+'levels'" :name="indextr+'levels'" rules="required" v-slot="{ errors }">
                  <vs-input :disabled="__isDisabledRawMaterial(status)" type="text" v-model="data[indextr].levels" name="levels" class="w-full"  :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather" />
                </ValidationProvider>
              </vs-td>

            </vs-tr>
          </template>
        </vs-table>

<!--        <vs-divider class="my-4" style="opacity: 0.2" color="" position="center"/>-->
<!--        <div v-for="(bap, index) in form.BAP_item" :key="index">-->
<!--          <div class="vx-row mb-3">-->
<!--            <div class="vx-col md:w-1/5 w-full md:mb-0">-->
<!--&lt;!&ndash;              <span class="text-bold " style="font-weight: bold">{{bap.name}}</span>&ndash;&gt;-->
<!--              <small class="label">Name</small> <br>-->
<!--              <span class="text-bold " style="font-weight: normal">{{ bap.name}}</span>-->
<!--            </div>-->
<!--            <div class="vx-col md:w-4/5 w-full md:mb-0">-->
<!--              <ValidationProvider :vid="index+'levels'" :name="index+'levels'" rules="required" v-slot="{ errors }">-->
<!--                <small class="label">Levels</small>-->
<!--                <vs-input :disabled="__isDisabledRawMaterial(status)" type="text" v-model="bap.levels" name="levels" class="w-full"  :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather" />-->
<!--              </ValidationProvider>-->
<!--            </div>-->
<!--          </div>-->
<!--          <vs-divider class="my-4" style="opacity: 0.2" color="" position="center"/>-->
<!--        </div>-->

        <div class="flex flex-wrap items-center justify-end">
          <vs-button v-if="status.is_raw_material_BAP_complete"  button="submit" class="ml-auto mt-2" :disabled="__isDisabledRawMaterial(status)">Save Changes</vs-button>
          <vs-button v-else button="submit" class="mt-2 ml-4" :disabled="__isDisabledRawMaterial(status)">Save Changes</vs-button>
          <!--          <vs-button class="ml-4 mt-2" type="border" color="warning">Reset</vs-button>-->
        </div>
      </form>
    </ValidationObserver>
  </vx-card>

</template>

<script>
  import { RepositoryFactory } from '@/repository/RepositoryFactory'
  const SupplierManufactureRepository = RepositoryFactory.get('supplierManufacture')
  const SupplierRawMaterialRepository = RepositoryFactory.get('supplierRawMaterial')

  import SuccessMessage from '@/mixins/SuccessMessage'
  import ErrorMessages from '@/mixins/ErrorMessages'
  import vSelect from "vue-select";


  export default {
    name: "SupplierManufacturingHome",
    data() {
      return {
        BAP_item_display_names: [
          'Beta-asarone', '1-Allyl-4methoxybenzene (Estragol)', 'Hydrocyanic acid', 'Menthofuran',
          '4-Allyl-1,2-dimethoxybenzene (Methyleugenol)', 'Pulegone', 'Quassin',
          '1-Allyl-3,4-methylene dioxy benzene (Safrole)', 'Teucrin A', 'Thujone (alpha and beta)', 'Coumarin'
        ],
        form: {
          is_contain_BAP: false,
          BAP_item: [
            {
              name:  "beta_asarone",
              levels: ""
            },
            {
              name:  "estragol",
              levels: ""
            },
            {
              name:  "hydrocyanic",
              levels: ""
            },
            {
              name:  "menthofuran",
              levels: ""
            },
            {
              name:  "methyleugenol",
              levels: ""
            },
            {
              name:  "pulegone",
              levels: ""
            },
            {
              name:  "quassin",
              levels: ""
            },
            {
              name:  "safrole",
              levels: ""
            },
            {
              name:  "teucrin-a",
              levels: ""
            },
            {
              name:  "thujone",
              levels: ""
            },
            {
              name:  "coumarin",
              levels: ""
            }
          ]
        },
        id: null,
        status: {}
      }
    },
    mixins: [SuccessMessage, ErrorMessages],
    components: {
      'v-select': vSelect,
    },
    methods: {
      onClickNext() {
        this.$emit('notify', 1)
      },
      onClickSubmit() {
        this.status.is_raw_material_BAP_complete ? this.onClickUpdate() : this.onClickCreate()
      },
      async onClickUpdate() {
        this.$vs.loading()
        try {
          const data= (await SupplierRawMaterialRepository.UpdateRawMaterialBaps(this.id, this.form))
          this.showSuccessMessage('Raw Material BAPs Details Updated!')
          this.onClickNext()
        }catch (e) {
          this.convertAndNotifyError(e)
        }
        this.$vs.loading.close()
      },
      async onClickCreate() {
        this.$vs.loading()
        try {
          const data= (await SupplierRawMaterialRepository.CreateRawMaterialBaps(this.form))
          this.showSuccessMessage('Raw Material BAPs Details Created!')
          this.onClickNext()
        }catch (e) {
          this.convertAndNotifyError(e)
        }
        this.$vs.loading.close()
      },

      async loadData() {
        this.$vs.loading()
        const {data} = (await SupplierRawMaterialRepository.getRawMaterialBaps(this.id)).data
        this.form =data
        this.$vs.loading.close()
      },
      async loadStatus() {
        this.$vs.loading()
        const {data} = (await SupplierRawMaterialRepository.getRawMaterialStatus(this.id)).data
        this.status =data
        this.$vs.loading.close()
      }
    },
    async mounted() {
      this.id = this.$route.params.id
      this.form.supplier_raw_material_id =  this.id
      await this.loadStatus()
      if (this.status.is_raw_material_BAP_complete ) {
        await this.loadData()
      }
    }

  }
</script>

<style scoped>

</style>
